module.exports = __webpack_public_path__ + "img/yuna500.7f06fd37.png";